class NavigationService {
    history: any;

    constructor() {
        this.history = null;
    }

    setHistory = (history: any) => {
        this.history = history;
    }

    navigate = (route: string, state?: any) => {
        if (!this.history) return;
        this.history.push(route, state);
    }

    replace = (route: string, state?: any) => {
        if (!this.history) return;
        this.history.replace(route, state);
    }

    goBack = () => {
        if (!this.history) return;
        this.history.goBack();
    }
}

const instance = new NavigationService();
export default instance;
